export const environment = {
  TPS_API: 'https://pg.test.sfey.com',
  IS_GOOGLE_PRODUCTION: false
};
